import { Map } from 'immutable';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  divider: {
    clear: 'both',
  },
}));

const SectionDivider = props => {
  const classes = useStyles();
  return (
    <Box className={classes.divider} mb={12} mt={12}>
      <Divider />
    </Box>
  );
};

const plugin = () => ({
  blockRendererFn: (block, { getProps }) => {
    const { page, readOnly } = getProps();
    const type = block.getType();
    if (type === 'section') {
      return {
        component: SectionDivider,
        editable: false,
      };
    }
    return null;
  },
  // blockStyleFn: (block, { getProps }) => {
  //   const { page, readOnly } = getProps();
  //   const type = block.getType();
  //   const data = block.getData();
  //   const alignment = data.get('alignment');
  //   return cx(
  //     // default overwrites
  //     style[page.type],
  //     style[alignment],
  //     { [style.addToCalendar]: type === 'event-contact' },
  //   );
  // },
  blockRenderMap: Map({
    section: {
      element: 'div',
      props: {},
      isBlockTypeMutable: false,
      fixed: false,
    },
  }),
});

export default plugin;
